export class SupplierSelectionFormModel {
  public services: string[] = [];
  public industries: string[] = [];
  public segmentsAir: string[] = [];
  public segmentsSea: string[] = [];
  public segmentsRoad: string[] = [];
  public segmentsRail: string[] = [];
  public regionsAfrica: { name: string; code: string }[] = [];
  public regionsAsia: { name: string; code: string }[] = [];
  public regionsAustraliaPacific: { name: string; code: string }[] = []
  public regionsEurope: { name: string; code: string }[] = [];
  public regionsNorthAmerica: { name: string; code: string }[] = [];
  public regionsSouthAmerica: { name: string; code: string }[] = [];

  constructor(init?: Partial<SupplierSelectionFormModel>) {
    Object.assign(this, init);
  }
}

export function IsSupplierSelectionFormValid(
  data: SupplierSelectionFormModel
): boolean {
  return (
    data.services.length === 0 ||
    data.industries.length === 0 ||
    data.segmentsAir.length === 0 ||
    data.segmentsSea.length === 0 ||
    data.segmentsRoad.length === 0 ||
    data.segmentsRail.length === 0 ||
    data.regionsAfrica.length === 0 ||
    data.regionsAsia.length === 0 ||
    data.regionsAustraliaPacific.length === 0 ||
    data.regionsEurope.length === 0 ||
    data.regionsNorthAmerica.length === 0 ||
    data.regionsSouthAmerica.length === 0
  );
}

export function GetEmptySupplierSelectionForm(): SupplierSelectionFormModel {
  return {
    services: [],
    industries: [],
    segmentsAir: [],
    segmentsSea: [],
    segmentsRoad: [],
    segmentsRail: [],
    regionsAfrica: [],
    regionsAsia: [],
    regionsAustraliaPacific: [],
    regionsEurope: [],
    regionsNorthAmerica: [],
    regionsSouthAmerica: [],
  };
}
